import { ComponentProps, FC } from 'react';
import styled from 'styled-components';
import { Box, Svg } from '@altermaind/web/ui';
import { SortDirection } from './types';

type SortArrowProps = {
  direction?: `${SortDirection}`;
  isSorted: boolean;
};

export const SortArrow: FC<SortArrowProps> = ({ direction, isSorted }) => {
  const isUp = !direction || direction === SortDirection.ASC;

  return (
    <Box
      display='inline-flex'
      alignItems='center'
      ml='xxxs'
      style={{
        transition: 'transform 0.2s, opacity 0.2s',
        transform: isUp ? 'rotate(0deg)' : 'rotate(180deg)',
        opacity: isSorted ? 1 : 0,
      }}
      className={!isSorted ? 'sort-arrow-hint' : undefined}
    >
      <Svg name='arrowUp' size='xs' fill='grey/light' />
    </Box>
  );
};

export const SortableHeaderBox = styled(Box)`
  &:hover .sort-arrow-hint {
    opacity: 0.5 !important;
  }
` as FC<ComponentProps<typeof Box>>;
